import React, { Component, Fragment } from 'react';
import { elements } from './_data_safety_layout';
import DayQualityElement from './DayQualityElement';
import '@app/components/sqdp/spa/styles/quality-layout.css';
import dayjs from 'dayjs';

class QualityLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 2, 'spa');
  };

  // getColorOfDay = (issueOfDay, dateNum) => {
  //   if(issueOfDay){

  //     if(issueOfDay.isRestDay){
  //       // if(issueOfDay.countDeliveryTotal <=0 && issueOfDay.countProductivityTotal <=0 && issueOfDay.countSafetyTotal <=0){
  //         return 'emtpy_state'
  //       }

  //     if(!issueOfDay.countQualityTotal || issueOfDay.countQualityTotal <=0){

  //       let today = dayjs();
  //       let selectedTime = dayjs(this.props.selectedMonth)
  //       if( today.get('month') <= selectedTime.get('month') && today.get('year') <= selectedTime.get('year') && dateNum == today.get('date')){
  //         return 'emtpy_state';
  //       }

  //       return 'green_state';
  //     }

  //     if(!issueOfDay.countNumberOfErrorProduct || issueOfDay.countNumberOfErrorProduct < 5){
  //       return 'yellow_state';
  //     }

  //     if(issueOfDay.countNumberOfErrorProduct >= 5){
  //       return 'red_state';
  //     }
  //   }

  //   return 'emtpy_state';
  // }

  getColorOfDay = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        // if(issueOfDay.countDeliveryTotal <=0 && issueOfDay.countProductivityTotal <=0 && issueOfDay.countSafetyTotal <=0){
        return 'emtpy_state';
      }

      if (!issueOfDay.countQualityTotal || issueOfDay.countQualityTotal <= 0) {
        let today = dayjs();
        let selectedTime = dayjs(this.props.selectedMonth);
        if (
          today.get('month') <= selectedTime.get('month') &&
          today.get('year') <= selectedTime.get('year') &&
          dateNum == today.get('date')
        ) {
          return 'emtpy_state';
        }

        return 'green_state';
      }

      if (!issueOfDay.countNumberProductDestroy) {
        return 'green_state';
      }

      if (issueOfDay.countNumberProductDestroy > 0 && issueOfDay.countNumberProductDestroy <= 5) {
        return 'yellow_state';
      }

      if (issueOfDay.countNumberProductDestroy > 5) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayQualityElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-quality">
          {/* Elements 1-4 */}
          {this.populateElements(1, 31)}
          {/* Information Table */}
          {/* {this.state.showInfo && (
            <Fragment>
              <div id="element-box" className={`${category}`}>
                <div className="number">{number}</div>
                <div className="symbol">{symbol}</div>
                <div className="element-name">{name}</div>
              </div>
              <div id="information">
                <div
                  onClick={this.closeInfo}
                  className="close-button"
                  title="Close Info"
                >
                  Close [&times;]
                </div>
                <div>
                  <h1 className="big_title">{name}</h1>
                  <span className={`cat_name ${category}`}>{category}</span>
                  {appearance && (
                    <div className="appearance">
                      <strong>Appearance:</strong> {appearance}
                    </div>
                  )}
                  <div className="atom_info">
                    <span>Atomic Mass: {atomic_mass} | </span>
                    <span>Density: {density}</span>
                    {molar_heat && <span> | Molar Heat: {molar_heat}</span>}
                    {melt && <span> | Melt: {melt}K</span>}
                    {boil && <span> | Boil: {boil}K</span>}
                  </div>
                  <div>
                    {summary} ...{" "}
                    <a target="_blank" href={source}>
                      Source
                    </a>
                  </div>
                </div>
              </div>
            </Fragment>
          )} */}

          {/* {this.populateElements(5, 57)}
          {this.populateElements(72, 89)}
          {this.populateElements(104, 118)}
          {this.populateElements(58, 71)}
          {this.populateElements(90, 103)} */}
        </div>
        <h3 className="center" style={{ paddingLeft: '30px', marginTop: '20px' }}>
          Quality
        </h3>
      </>
    );
  }
}

export default QualityLayout;
